import UpsellBanner from 'components/Common/UpsellBanner'
import { FlightsClassTypes } from 'constants/flight'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import useAirportSearch from 'hooks/Flights/useAirportSearch'
import useFlightDeals from 'hooks/Flights/useFlightDeals'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import { sortBy } from 'lib/array/arrayUtils'
import React, { useCallback, useMemo } from 'react'

interface Props {
  originAirportCode: string
  destinationAirportCode: string
  offer: App.Offer
}

function OfferPageFlightDealBanner(props: Props) {
  const {
    destinationAirportCode,
    originAirportCode,
    offer,
  } = props
  const [deals] = useFlightDeals('all', {
    originAirportCode,
    destinationAirportCode,
  })
  const dispatch = useOfferPageDispatch()
  const [airportSearchResults] = useAirportSearch(destinationAirportCode)

  const activeDeal = useMemo(() => {
    return sortBy(deals, (deal) => deal.perAdultPrice, 'asc')[0]
  }, [deals])

  const locationCaption = useMemo(() => {
    const destinationAirport = airportSearchResults.find((airport) => airport.airportCode === destinationAirportCode)

    if (!destinationAirport) {
      return offer.locationHeading || ''
    }

    return `${destinationAirport.cityDesc} (${destinationAirport.airportName} - ${destinationAirport.airportCode})`
  }, [airportSearchResults, destinationAirportCode, offer?.locationHeading])

  const handleCheckAvailability = useCallback(() => {
    dispatch({ type: OfferPageActions.toggleFilter, filter: 'checkin' })
    dispatch({ type: OfferPageActions.setFlights, flights: true })
  }, [dispatch])

  if (!activeDeal) {
    return null
  }

  return (
    <UpsellBanner
      carrierLogo={activeDeal.carrier.logo?.url}
      carrierName={activeDeal.carrier.name}
      destinationName={locationCaption}
      price={activeDeal.perAdultPrice}
      onCheckAvailability={handleCheckAvailability}
      fareType={activeDeal.fareType}
      fareClass={activeDeal.fareClass as FlightsClassTypes}
    />
  )
}

export default withOfferPageAndReduxState((state) => ({
  offer: state.offer,
}), OfferPageFlightDealBanner)
